import { type QueryClient } from '@tanstack/react-query';

import { DEPOSITS_QUERY_KEY, FINANCE_CLIENTS_QUERY_KEY } from '../../../finance/api';
import { formatChf } from '../../../finance/utils';
import { clientFinanceKey } from '../../api';
import { biddingModeKey } from '../../hooks/use-bidding-mode';
import { formatShortDate } from '../../utils';

/**
 * `CHF 7 052` / `CHF 7 052,40` — whole francs without cents, anything else with
 * exactly two decimals (D-9). ONE implementation for all of admin, owned by
 * `finance/utils`; re-exported here so the client page's imports stay put.
 */
export { formatChf };

/** `28.09.2026` — the client page's date format, for a parsed `Date`. */
export function formatDate(value: Date | null | undefined): string {
  return value ? formatShortDate(value.toISOString()) : '—';
}

/** `+CHF 700` / `−CHF 300` — a signed journal figure (the client's sign: + credits them). */
export function formatSignedChf(value: number): string {
  if (value === 0) return formatChf(0);
  return `${value > 0 ? '+' : '−'}${formatChf(Math.abs(value))}`;
}

/**
 * Everything a recorded payment or adjustment can change: this tab, the
 * «Режим ставок» card (deposit → ceiling), the clients list, and the finance
 * page's deposits table, client rollup and journal.
 */
export function invalidateClientMoney(queryClient: QueryClient, userId: string): void {
  for (const queryKey of [
    clientFinanceKey(userId),
    biddingModeKey(userId),
    ['clients'],
    DEPOSITS_QUERY_KEY,
    FINANCE_CLIENTS_QUERY_KEY,
    ['admin', 'finance', 'journal'],
  ] as const) {
    void queryClient.invalidateQueries({ queryKey });
  }
}
